import { createInstance } from "../api/instance";

export default (context) => {
  createInstance(context);
};
